var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPhone = function SvgPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 12 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.028 10.94a10 10 0 0 1-4.359-2.564 10 10 0 0 1-2.564-4.359l-.008-.028c-.074-.26-.131-.46-.132-.737 0-.315.102-.71.256-.985.266-.473.836-1.079 1.329-1.328a1.5 1.5 0 0 1 1.354 0c.421.213.89.69 1.152 1.092a1.5 1.5 0 0 1 0 1.635c-.087.133-.21.256-.354.4-.044.044-.094.076-.06.144a6.8 6.8 0 0 0 1.325 1.868 6.8 6.8 0 0 0 1.868 1.326c.07.034.098-.014.145-.061.143-.143.266-.267.4-.354a1.5 1.5 0 0 1 1.634 0c.392.255.881.734 1.092 1.152a1.5 1.5 0 0 1 0 1.354c-.249.493-.855 1.063-1.328 1.329-.275.154-.67.257-.985.256-.276 0-.477-.058-.737-.132z",
    clipRule: "evenodd"
  })));
};
export default SvgPhone;